import './AppSidebar.css'
import {
  Box,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import InboxIcon from '@mui/icons-material/MoveToInbox'
import MailIcon from '@mui/icons-material/Mail'
import { type CSSObject, styled, type Theme } from '@mui/material/styles'
import clsx from 'clsx'
import { useNavigate } from 'react-router-dom'
import { SpaceSidebarContainer } from '@/spaces/sidebar/SpaceSidebarContainer.tsx'
import { useContext } from 'react'
import { sidebarContext } from './SidebarContextProvider.tsx'
import { useResizeDrag } from '@/common/hooks/useResizeDrag'

import { darkGrey } from '@/core/theme/colors.ts'

const openedMixin = (theme: Theme): CSSObject => ({
  width: 'var(--left-sidebar-open-width)',
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
})

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)})`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)})`,
  },
})

const Sidebar = styled('div', { shouldForwardProp: (prop) => prop !== 'open' })<{
  open: boolean
}>(({ theme, open }) => ({
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  backgroundColor: theme.palette.mode == 'light' ? '#FFFFFF' : darkGrey[100],
  position: 'relative',
  ...(open ? openedMixin(theme) : closedMixin(theme)),
}))

export default function AppSidebar() {
  const { sidebarOpen, setSidebarOpen, sidebarWidth, setSidebarWidth } =
    useContext(sidebarContext)!

  const startResize = useResizeDrag({
    cssVar: '--left-sidebar-open-width',
    direction: 'right',
    minWidth: 150,
    maxWidth: 600,
    onResizeEnd: setSidebarWidth,
  })

  const navigate = useNavigate()

  // const items = [
  //   {
  //     text: 'Profile',
  //     icon: <InboxIcon />,
  //   },
  //   {
  //     text: 'Settings',
  //     icon: <MailIcon />,
  //     onClick: onSettingsButtonClicked,
  //   },
  // ]

  const handleDrawerOpen = () => {
    setSidebarOpen(true)
  }

  const handleDrawerClose = () => {
    setSidebarOpen(false)
  }

  function handleProfileClicked() {
    navigate('/profile')
  }

  function onSettingsButtonClicked() {
    navigate('/settings')
  }

  return (
    <Sidebar
      className={clsx('appSidebar', { open: sidebarOpen })}
      open={sidebarOpen}
      sx={{
        borderRight: (theme) => {
          return `1px solid ${theme.palette.divider}`
        },
      }}
    >
      <Box
        className="sidebarOpenBtnContainer"
        sx={{ borderBottom: (theme) => `1px solid ${theme.palette.divider}` }}
      >
        <IconButton
          className={'sidebarOpenBtn'}
          color="inherit"
          aria-label="open drawer"
          onClick={handleDrawerOpen}
          edge="start"
          sx={[sidebarOpen && { display: 'none' }]}
        >
          <MenuIcon />
        </IconButton>
        <IconButton
          className={'sidebarOpenBtn'}
          onClick={handleDrawerClose}
          sx={[!sidebarOpen && { display: 'none' }]}
        >
          <ChevronLeftIcon />
        </IconButton>
      </Box>
      {/*<Divider />*/}
      <SpaceSidebarContainer {...{ sidebarOpen: sidebarOpen }} />
      {sidebarOpen && <Divider />}
      {sidebarOpen && (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            right: 0,
            width: '4px',
            height: '100%',
            cursor: 'col-resize',
            zIndex: 10,
            '&:hover': { bgcolor: 'primary.main', opacity: 0.4 },
          }}
          onMouseDown={(e) => startResize(e, sidebarWidth)}
        />
      )}
      {/*<div>*/}
      {/*  <List>*/}
      {/*    {items.map((item, _) => (*/}
      {/*      <ListItem key={item.text} disablePadding>*/}
      {/*        <ListItemButton className="sidebarListItem" onClick={item.onClick}>*/}
      {/*          <ListItemIcon className="sidebarListItem">{item.icon}</ListItemIcon>*/}
      {/*          <ListItemText className="sidebarListItem" primary={item.text} />*/}
      {/*        </ListItemButton>*/}
      {/*      </ListItem>*/}
      {/*    ))}*/}
      {/*  </List>*/}
      {/*</div>*/}
    </Sidebar>
  )
}
